import { render, staticRenderFns } from "./home-tabs-big-item.vue?vue&type=template&id=7082ec3c&scoped=true&"
import script from "./home-tabs-big-item.vue?vue&type=script&lang=js&"
export * from "./home-tabs-big-item.vue?vue&type=script&lang=js&"
import style0 from "./home-tabs-big-item.vue?vue&type=style&index=0&id=7082ec3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082ec3c",
  null
  
)

export default component.exports